import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { SupportGuidComponent } from './guid/guid.component'
import { SupportOperationComponent } from './operation/operation.component'
import { SupportQuestionComponent } from './question/question.component'
import { SupportWelcomeComponent } from './welcome/welcome.component'

const routes: Routes = [
  { path: 'guid', component: SupportGuidComponent },
  { path: 'question', component: SupportQuestionComponent },
  { path: 'operation', component: SupportOperationComponent },
  { path: 'welcome', component: SupportWelcomeComponent },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupportRoutingModule {}
